import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class LoaderCustomService {
    isLoading = new Subject<boolean>();
    show() {
        this.isLoading.next(true);
    }
    showTest() {
        this.isLoading.next(true);
    }
    hideTest() {
        this.isLoading.next(false);
    }
    hide() {
        this.isLoading.next(false);
    }
}